import script from "./UserLastModified.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserLastModified.vue?vue&type=script&setup=true&lang=ts"

import "./UserLastModified.vue?vue&type=style&index=0&id=deca6ac2&lang=css"

const __exports__ = script;

export default __exports__